import React from 'react';
import Layout from '../../../components/Layout';
import Reveal, { SplitWords } from '../../../components/Reveal';

/**
 * @author Nelson
 */
const SupportService = () => (
    <Layout title="Support">
        <header className="page__head">
            <h1 className="page__eyebrow reveal" style={{ '--reveal-delay': '80ms' }}>
                Support
            </h1>
            <h2 className="page__title page__title--display">
                <SplitWords text="Need Help?" start={200} />
            </h2>
        </header>

        <div className="prose">
            <Reveal as="p" delay={420}>
                We’re here to assist you with any issues, questions, or feedback regarding our apps.
            </Reveal>
            <Reveal as="p" delay={490}>
                You can reach out to us directly by email:
            </Reveal>
            <Reveal delay={560}>
                <a className="contact" href="mailto:customersupport@appancestor.com">
                    <span className="contact__icon" aria-hidden="true">📩</span>
                    <span className="contact__link">customersupport@appancestor.com</span>
                </a>
            </Reveal>
            <Reveal as="p" delay={630}>
                We usually respond within 24–48 hours.
            </Reveal>
        </div>
    </Layout>
);

export default SupportService;
